<div class="phone-container">
  <label>{{ label }}</label>
  <div class="phone-fields">
    <app-select-input
      label="Type"
      [control]="phoneTypeControl"
      [options]="phoneTypes" placeholder="Select a Type">
    </app-select-input>
    <app-text-input
      label="Country Code"
      [control]="phoneCountryCodeControl">
    </app-text-input>
    @if(phoneTypeControl.value?.value != 'Mobile'){
      <app-text-input
        label="Area Code"
        [control]="phoneAreaCodeControl">
      </app-text-input>
    }
    <app-text-input
      label="Phone Number"
      [control]="phoneNumberControl">
    </app-text-input>
  </div>
  @if (showError && errorMessages.length) {
    @for (msg of errorMessages; track msg) {
      <mat-error>{{ msg }}</mat-error>
    }
  }
</div>
